import Modal from '@src/components/modal';
import React, { useCallback, useRef } from 'react';
import { noop } from '@src/utils/common-util.js';
import useUnmount from '@src/utils/hooks/use-unmount';

const useModal = (Component, settings) => {
  const ref = useRef(noop);
  const open = useCallback(
    ({ extraProps } = {}) => {
      ref.current();
      ref.current = Modal.append(props => (
        <Modal centerContent visible={props.visible} onClose={props.onClose} afterClose={props.afterClose}>
          <Component onClose={props.onClose} {...settings || {}} {...extraProps} />
        </Modal>
      )).close;
      return ref.current;
    },
    [settings]
  );
  useUnmount(() => {
    ref.current();
  });
  const close = useCallback(() => ref.current(), []);
  return { open, close };
};

export default useModal;
